import { lazy } from "react";
import { createFileRoute } from "@tanstack/react-router";
import { seoHead } from "@/config/seoHead";

const MobileApp = lazy(() => import("@/pages/MobileApp"));

export const Route = createFileRoute("/verktyg/mobilapp")({
  head: () => seoHead("/verktyg/mobilapp"),
  component: () => <MobileApp />,
});
